import Dropzone from "dropzone/dist/min/dropzone.min";
Dropzone.autoDiscover = false;

export function init() {
    hideMessage();
    loadDatatable();
    loadDropzone();
    changeVisible();
    textareaEnterPressing();
    rejectBookingModal();
    loadSelectPicker();
    handleAllergenSelect();
    loadingScreen();
    setRushHours();
}

/**
 * nascondiamo il messaggio di successo nel cms
 */
function hideMessage(){
    $(".session-message").delay(3500).fadeOut();
}

/**
 * carichiamo la datatable
 */
function loadDatatable() {
    $('.data-table').DataTable({
        "pageLength": 25,
        "sorting": [],
        "language": {
            "url": "/api/lang/pagination/datatable"
        },
        "autoWidth": false,
        "responsive": true,
        "columnDefs":  [
            { "targets": 'no-sort', "orderable": false }
        ]
    });
}

/**
 * carichiamo la dropzone
 */
function loadDropzone() {
    $(".dropzone").each(function () {
        var _this = $(this);
        _this.dropzone({
            url: _this.data('upload-url'),
            maxFilesize: 10,
            maxFiles: _this.data('max-files'),
            acceptedFiles: _this.data('accepted-files'),
            addRemoveLinks: true,
            init: function() {
                var thisDropzone = this;
                if (_this.data('get-url')){
                    $.getJSON(_this.data('get-url'), function(data) {
                        if (data) {
                            $.each(data, function(index, val) {
                                var mockFile = { name: val.filename, size: val.size };
                                mockFile.accepted = true;
                                thisDropzone.files.push(mockFile);
                                thisDropzone.options.addedfile.call(thisDropzone, mockFile);
                                thisDropzone.options.thumbnail.call(thisDropzone, mockFile, val.filepath);
                                thisDropzone.emit("complete", mockFile);
                            });
                        }
                    });
                }
            },
            maxfilesexceeded: function(file) {
                this.removeAllFiles();
                this.addFile(file);
            },
            renameFile: function(file) {
                var dt = new Date();
                var time = dt.getTime();
                var filename = file.name.replace(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '').replace(' ', '_').toLowerCase();
                return time+'_'+filename;
            },
            sending: function(file, xhr, formData) {
                formData.append("_token", $('[name=_token]').val());
            },
            removedfile: function(file)
            {
                var name = (file.upload === undefined) ? file.name : file.upload.filename;
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });
                $.ajax({
                    type: 'POST',
                    url: _this.data('delete-url'),
                    data: {filename: name},
                    success: function (data){
                        console.log("File has been successfully removed!!");
                    },
                    error: function(e) {
                        console.log(e);
                    }});
                var fileRef;
                return (fileRef = file.previewElement) != null ?
                    fileRef.parentNode.removeChild(file.previewElement) : void 0;
            },
            success: function (file, response) {
                if (_this.data('reload-page')){
                    location.reload();
                }
            },
            error: function (file, response) {
                console.log(response);
                return false;
            }
        });
    });
}

/**
 * otteniamo l'id e la tabella del record a cui cambiare la visibilità
 */
function changeVisible() {
    $(".change-visibility").on('click', function () {
        var _this = $(this);
        var id = _this.data('id');
        var url = _this.data('url');

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'PUT',
            url: url,
            data:  { id: id},
            dataType: 'json',
            success: function(result) {
                if (result['visibility']) {
                    _this.removeClass('btn-danger').addClass('btn-success').html(result['text']);
                } else {
                    _this.removeClass('btn-success').addClass('btn-danger').html(result['text']);
                }
                if (result['title'] !== undefined) {
                    _this.attr('title', result['title']);
                }
            }
        });
    });
}

function textareaEnterPressing() {
    $("#timetables").bind('keypress', function(e) {
        if(e.keyCode==13){
            this.value = this.value.substring(0, this.selectionStart) + "" + "\n" + this.value.substring(this.selectionEnd, this.value.length);
        }
    });
}

/**
 * modal per il rifiuto della prenotazione
 */
function rejectBookingModal() {
    var myModal = $("#rejectBookingModal");
    myModal.modal({show: false});
    $(".reject_booking").click(function() {
        $("#rejectBookingForm").attr('action', $(this).data('url'));
        $("#rejectBookingModal #id").val($(this).data('id'));
        myModal.modal('show');
    });
}

/**
 * carichiamo il bootstrap multiselect
 */
function loadSelectPicker() {
    $(".selectpicker").each(function () {
        $(this).selectpicker();
    });
}

/**
 * gestiamo la select degli allergeni, con gli "hashtags" (gli allergeni una volta selezionati)
 */
function handleAllergenSelect() {
    var selectAllergens = $("#select-allergens");

    selectAllergens.on('changed.bs.select', function (e) {
        console.log('selezionato');
        $("#selected-allergens-container").html('');

        var options = $('#select-allergens option:selected');

        $(options).each(function(){
            var template = "" +
                "<div class='selected-allergen d-flex align-items-center' id='"+$(this).val()+"'>" +
                    "<img src='" + $(this).data('image') + "' alt='"+$(this).text()+"' class='allergen-image'>" +
                    "<div class='text'>"+
                        "<span>"+$(this).text()+"</span>"+
                        "<button class='close'><i class='fa fa-times'></i></button>" +
                    "</div>" +
                "</div>";
            $("#selected-allergens-container").append(template);
        });
    });

    $(document).on('click', '.close', function(){
        var _this = $(this).parent().parent();
        _this.remove();

        selectAllergens.find('[value='+_this.attr('id')+']').prop('selected', false);
        var values = selectAllergens.val();
        selectAllergens.selectpicker('deselectAll');
        selectAllergens.selectpicker('val', values);
        selectAllergens.selectpicker('refresh');
    });

    // quando carichiamo la pagina settiamo gli elementi a selected nel blade, mentre qua facciamo il refresh per mostrare i singoli blocchi in basso
    var values = selectAllergens.val();
    selectAllergens.selectpicker('val', values);
    selectAllergens.selectpicker('refresh');
}

/**
 * facciamo partire le schermate di loading
 */
function loadingScreen() {
    let loading = $(".loading");

    loading.click(function () {
        if ($(this).is(':button')) {
            HoldOn.open({
                theme:"custom",
                content:'<div class="spinner"><div class="dot1"></div><div class="dot2"></div></div>',
                message:$(this).data('loading-text'),
                textColor:"white"
            });
        }
    });

    loading.on('submit', function () {
        HoldOn.open({
            theme: "custom",
            content: '<div class="spinner"><div class="dot1"></div><div class="dot2"></div></div>',
            message: $(this).data('loading-text'),
            textColor: "white"
        });
    });
}

/**
 * interazione con i bottoni della webview in app
 */
export function webviewActions() {
    $("#btnPopWebview").click(function () {
        if (typeof Action !== 'undefined') {
            Action.postMessage('pop');
        }
    });
    $("#btnHomepageApp").click(function () {
        if (typeof Action !== 'undefined') {
            Action.postMessage('home');
        }
    });
}

/**
 * abilitiamo o disabilitiamo gli orari di punta dei ristoranti
 */
function setRushHours() {
    $(".btn-rush-hour").on('click', function () {
        var btn = $(this);
        btn.removeClass('hide-icon').addClass('show-icon');
        var data = {restaurant_id: btn.data('restaurant-id'), hour_id: btn.data('hour-id'), day_id: btn.data('day-id')};
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
            type: 'POST',
            url: btn.data('url'),
            data: data,
            datatype: 'json',
            success: function (isRushHour){
                // se è un orario di punta avrà il background rosso
                if (isRushHour) {
                    btn.removeClass('btn-success').addClass('btn-danger');
                } else { // altrimenti avrà il background verde
                    btn.removeClass('btn-danger').addClass('btn-success');
                }
            },
            complete: function () {
                btn.removeClass('show-icon').addClass('hide-icon');
            }
        });
    });
}